import { IApiError } from '@frontend/request';

import { experienceAPI } from '@aqx-core/common/api/experience';
import { IExtendExperienceParams, IQueryIdentifierResponse } from '@aqx-core/common/api/experience/model';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class ExperienceAPIController {
  public queryExperienceIdentifier = async (
    params: IExtendExperienceParams,
    callbacks: IAPIControllerCallbacks<IQueryIdentifierResponse>
  ) => {
    try {
      const { result } = await experienceAPI.queryExperienceIdentifier(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public extendExperienceThroughSalesforce = async (
    params: IExtendExperienceParams,
    callbacks: IAPIControllerCallbacks<IQueryIdentifierResponse>
  ) => {
    try {
      const { result } = await experienceAPI.extendExperienceThroughSalesforce(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const experienceAPIController = new ExperienceAPIController();
